import { useCallback, useMemo, useState } from 'react'
import type { ReactNode } from 'react'
import type { LoginAutenticado, UserToken } from '@/types/auth'
import { clearSession, getUserData, saveSession } from '@/services/session'
import { can as canDo, isAdminUser } from '@/utility/permissions'
import type { Acao } from '@/utility/permissions'
import { AuthContext } from './auth-context'
import type { AuthContextValue } from './auth-context'

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [user, setUser] = useState<UserToken | null>(() => getUserData())

  const signIn = useCallback((login: LoginAutenticado) => {
    saveSession(login)
    setUser(login.userToken)
  }, [])

  const signOut = useCallback(() => {
    clearSession()
    setUser(null)
  }, [])

  const value = useMemo<AuthContextValue>(
    () => ({
      user,
      isAuthenticated: Boolean(user),
      isAdmin: isAdminUser(user),
      can: (acao: Acao) => canDo(user, acao),
      signIn,
      signOut,
    }),
    [signIn, signOut, user],
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}
